import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { dataType, documentPropType, mergeDocumentType } from "custom-prop-types";
import { Button } from "components/common/button";
import styles from "components/documents/merge-documents-modal.scss";
import { Modal } from "components/common/modal";
import { MergeGrid } from "components/documents/merge-grid";

export const MergeDocumentsModal = (props) => (
  <Modal
    isVisible={ props.isMergeDocumentsMode }
    onClose={ props.onEndMergeDocumentsMode }
    transitionName="merge-documents"
  >
    <ModalChild { ...props } selectedDocuments={ props.selectedDocuments } />
  </Modal>
);

MergeDocumentsModal.propTypes = {
  isMergeDocumentsMode: PropTypes.bool.isRequired,
  onEndMergeDocumentsMode: PropTypes.func.isRequired,
  selectedDocuments: PropTypes.arrayOf(documentPropType).isRequired
};

const ModalChild = ({
  columns,
  isMergeDocumentsLoading,
  onDeselectMergeDocument,
  onEndMergeDocumentsMode,
  onMergeDocuments,
  onSelectMergeDocument,
  onSelectMergeField,
  mergeDocument,
  preferredCurrency,
  selectedMergeDocumentId,
  selectedDocuments
}) => {
  const rows = getRow(selectedDocuments, selectedMergeDocumentId, preferredCurrency);
  if (selectedDocuments.length > 5) {
    return (
      <div className={ styles["error-container"] }>
        <h1>Too many documents selected.</h1>
        <p>You can only merge 5 documents at a time.</p>
        <Button onClick={ onEndMergeDocumentsMode } primary>OK</Button>
      </div>
    );
  }
  return (
    <div className={ styles["grid-container"] }>
      <h2>Merge documents</h2>
      <p>
        Select a document that will be the basis of the merge,
        and/or select the individual fields that you would like to keep.
      </p>
      <MergeGrid
        columns={ columns }
        firstRow={ rows[0] }
        onCellSelected={ onSelectMergeField }
        onRowsDeselected={ onDeselectMergeDocument }
        onRowsSelected={ onSelectMergeDocument }
        rowHeight={ 35 }
        rows={ rows }
        rowsCount={ selectedDocuments.length }
        selectedFields={ mergeDocument }
        sortColumn={ "uploaded" }
        sortDirection={ "DESC" }
        totalResults={ selectedDocuments.length }
      />
      <div className={ styles["merge-buttons"] }>
        <Button link onClick={ onEndMergeDocumentsMode }>cancel</Button>
        <Button loading={ isMergeDocumentsLoading } onClick={ () => onMergeDocuments() } primary>
          Confirm merge
        </Button>
      </div>
    </div>
  );
};

ModalChild.defaultProps = {
  mergeDocument: null,
  selectedMergeDocumentId: ""
};

ModalChild.propTypes = {
  columns: PropTypes.arrayOf(dataType).isRequired,
  isMergeDocumentsLoading: PropTypes.bool.isRequired,
  mergeDocument: mergeDocumentType,
  onDeselectMergeDocument: PropTypes.func.isRequired,
  onEndMergeDocumentsMode: PropTypes.func.isRequired,
  onMergeDocuments: PropTypes.func.isRequired,
  onSelectMergeDocument: PropTypes.func.isRequired,
  onSelectMergeField: PropTypes.func.isRequired,
  preferredCurrency: PropTypes.string.isRequired,
  selectedDocuments: PropTypes.arrayOf(documentPropType).isRequired,
  selectedMergeDocumentId: PropTypes.string
};

const getRow = (documents, selectedMergeDocumentId, preferredCurrency) => (
  documents.map(document => R.merge(
    document,
    {
      isSelected: selectedMergeDocumentId.includes(document.id),
      categories: JSON.stringify(document.categories),
      defaultCurrency: preferredCurrency,
      paymentType: JSON.stringify(document.paymentType)
    }
  ))
);



// WEBPACK FOOTER //
// ./src/js/components/documents/modals/merge-documents-modal.jsx